// extracted by mini-css-extract-plugin
export default {"btnPrimary":"ck4l9m1en","btnWhite":"csj8259t5","btnBlack":"cl4rbw6e7 ck4l9m1en","btnTransparent":"cjb1isj5r ck4l9m1en"};